import { Route } from 'vue-router'
import store from '@/store'
import {GET_MODE, IS_USER_LOGGED_IN} from '@/store/getter-types'
import {getSetting} from "@/services/settings";
import moment from "moment";

export const rootPageGuard = (to: Route, from: Route, next: Function): void => {
  let localeIsoWeek = localStorage.getItem('uiLanguageCodeApp') || navigator.language || process.env.VUE_APP_I18N_LOCALE || 'sk'
  if (store.getters[IS_USER_LOGGED_IN] && getSetting('boarder.force_pin_change')!.value === 'true' && store.getters[GET_MODE] !== 'kiosk') {
    next('/change-password')
  } else if(store.getters[IS_USER_LOGGED_IN] && store.getters[GET_MODE] !== 'kiosk') {
    next('/dashboard')
  } else if(store.getters[IS_USER_LOGGED_IN] && store.getters[GET_MODE] === 'kiosk') {
    const isoWeek: string = moment().locale('localeIsoWeek').format('GGGG[W]WW')
    const date: string = moment().locale('localeIsoWeek').format('YYYY-MM-DD')
    next(`/order/${isoWeek}/${date}`)
  } else {
    next('/login')
  }
}

export const loginPageGuard = (to: Route, from: Route, next: Function): void => {
  let localeIsoWeek = localStorage.getItem('uiLanguageCodeApp') || navigator.language || process.env.VUE_APP_I18N_LOCALE || 'sk'
  if (store.getters[IS_USER_LOGGED_IN] && getSetting('boarder.force_pin_change')!.value === 'true' && store.getters[GET_MODE] !== 'kiosk') {
    next('/change-password')
  } else if(store.getters[IS_USER_LOGGED_IN] && store.getters[GET_MODE] !== 'kiosk') {
    next('/dashboard')
  } else if(store.getters[IS_USER_LOGGED_IN] && store.getters[GET_MODE] === 'kiosk') {
    const isoWeek: string = moment().locale('localeIsoWeek').format('GGGG[W]WW')
    const date: string = moment().locale('localeIsoWeek').format('YYYY-MM-DD')
    next(`/order/${isoWeek}/${date}`)
  } else {
    next()
  }
}

export const isUserLoggedInGuard = (to: Route, from: Route, next: Function): void => {
  let localeIsoWeek = localStorage.getItem('uiLanguageCodeApp') || navigator.language || process.env.VUE_APP_I18N_LOCALE || 'sk'
  if (store.getters[IS_USER_LOGGED_IN] && getSetting('boarder.force_pin_change')!.value === 'true' && store.getters[GET_MODE] !== 'kiosk') {
    next('/change-password')
  } else if(store.getters[IS_USER_LOGGED_IN] && store.getters[GET_MODE] !== 'kiosk') {
    next()
  } else if(store.getters[IS_USER_LOGGED_IN] && store.getters[GET_MODE] === 'kiosk') {
    if(to.name === 'Order') {
      next()
    } else {
      const isoWeek: string = moment().locale('localeIsoWeek').format('GGGG[W]WW')
      const date: string = moment().locale('localeIsoWeek').format('YYYY-MM-DD')
      next(`/order/${isoWeek}/${date}`)
    }
  } else {
    next('/login')
  }
}

export const isPinChangedGuard = (to: Route, from: Route, next: Function): void => {
  let localeIsoWeek = localStorage.getItem('uiLanguageCodeApp') || navigator.language || process.env.VUE_APP_I18N_LOCALE || 'sk'
  if (store.getters[IS_USER_LOGGED_IN] && getSetting('boarder.force_pin_change')!.value === 'true' && store.getters[GET_MODE] !== 'kiosk') {
    next()
  } else if(store.getters[IS_USER_LOGGED_IN] && store.getters[GET_MODE] !== 'kiosk') {
    next('/dashboard')
  } else if(store.getters[IS_USER_LOGGED_IN] && store.getters[GET_MODE] === 'kiosk') {
    const isoWeek: string = moment().locale('localeIsoWeek').format('GGGG[W]WW')
    const date: string = moment().locale('localeIsoWeek').format('YYYY-MM-DD')
    next(`/order/${isoWeek}/${date}`)
  } else {
    next('/login')
  }
}
